export const foglalkozasData = [
{
        "date": "2026-01-23",
        "title":"Kézművesség",
       "mainimage":"../images/nappali/2026.01.23/1.jpg",
        "images": 
          {
          "image1": "../images/nappali/2026.01.23/1.jpg",
          "image2": "../images/nappali/2026.01.23/2.jpg",
          "image3": "../images/nappali/2026.01.23/3.jpg",
          "image4": "../images/nappali/2026.01.23/4.jpg",
          "image5": "../images/nappali/2026.01.23/5.jpg",
          "image6": "../images/nappali/2026.01.23/6.jpg",
          "image7": "../images/nappali/2026.01.23/7.jpg",
          "image8": "../images/nappali/2026.01.23/8.jpg",
          "image9": "../images/nappali/2026.01.23/9.jpg",
          "image10": "../images/nappali/2026.01.23/10.jpg",
          }
        
    },
    {
        "date": "2026-01-05",
        "title":"Mesenap",
       "mainimage":"../images/nappali/2026.01.05/7.jpg",
        "images": 
          {
          "image1": "../images/nappali/2026.01.05/1.jpg",
          "image2": "../images/nappali/2026.01.05/2.jpg",
          "image3": "../images/nappali/2026.01.05/3.jpg",
          "image4": "../images/nappali/2026.01.05/4.jpg",
          "image5": "../images/nappali/2026.01.05/5.jpg",
          "image6": "../images/nappali/2026.01.05/6.jpg",
          "image7": "../images/nappali/2026.01.05/7.jpg",
          "image8": "../images/nappali/2026.01.05/8.jpg",
          "image9": "../images/nappali/2026.01.05/9.jpg",
          }
        
    },
    {
        "date": "2026-06-08",
        "title":"Kertészkedés",
       "mainimage":"../images/nappali/2025.06.08/1.jfif",
        "images": 
          {
          "image1": "../images/nappali/2025.06.08/1.jfif",
          "image2": "../images/nappali/2025.06.08/2.jfif",
          "image3": "../images/nappali/2025.06.08/3.jfif",
          "image4": "../images/nappali/2025.06.08/4.jfif",
          "image5": "../images/nappali/2025.06.08/5.jfif",
          "image6": "../images/nappali/2025.06.08/6.jfif",
          "image7": "../images/nappali/2025.06.08/7.jfif",
          "image8": "../images/nappali/2025.06.08/8.jfif",
          "image9": "../images/nappali/2025.06.08/9.jfif",
          }
        
    },
    ];